export enum ERROR_CODE {
  E214_AUTH = 'E214_AUTH',
  E283_AUTH = 'E283_AUTH',
  E278_AUTH = 'E278_AUTH',
  E217_AUTH = 'E217_AUTH',
  OTP_410 = 'OTP_410',
  OTP_412 = 'OTP_412',
  OTP_411 = 'OTP_411',
  OTP_409 = 'OTP_409',
  OTP_413 = 'OTP_413',
  E210_AUTH = 'E210_AUTH',
  E216_AUTH = 'E216_AUTH',
}
